import Vuex from 'vuex';
import auth from './modules/auth';
import currency from './modules/currency';
import city from './modules/city';
import category from './modules/category';
import cardStatus from './modules/cardStatus';
import stores from './modules/stores';
import receiptAddress from './modules/receiptAddress';
import cardCenters from './modules/cardCenters';
import setting from './modules/setting';
import advertisement from './modules/advertisement';
import subscriber from './modules/subscriber';
import rechargeCard from './modules/rechargeCard';
import order from './modules/order';
import GameCategory from './modules/GameCategory';
import user from './modules/user';
import GroupRechargeCard from './modules/GroupRechargeCard';
import GroupRechargeCardAssign from './modules/GroupRechargeCardAssign';
import settlement from './modules/settlement';
import dashboard from './modules/dashboard';
import Cpus from './modules/Cpus';
import Gpu from './modules/Gpu';
import Ram from './modules/Ram';
import Game from './modules/Game';
import news from './modules/news';
import gameStory from './modules/gameStory';
import payment from './modules/payment';
import statistics from './modules/statistics';
import Discussion from './modules/Discussion';
import gameTrailer from './modules/gameTrailer';
import gameActivity from './modules/gameActivity';
import GameIGDB from './modules/GameIGDB';
import webhook from './modules/webhook';
import EventIGDB from './modules/EventIGDB';
import giveaways from './modules/giveaways';
import AnalyticsVisitors from './modules/AnalyticsVisitors';
const store = new Vuex.Store({
    modules: {
        admin: {
            namespaced: true,
            modules: {
                auth: auth,
                currency: currency,
                city: city,
                category: category,
                cardStatus: cardStatus,
                stores: stores,
                receiptAddress: receiptAddress,
                cardCenters: cardCenters,
                setting: setting,
                advertisement: advertisement,
                subscriber: subscriber,
                rechargeCard: rechargeCard,
                order: order,
                GameCategory: GameCategory,
                user: user,
                GroupRechargeCard: GroupRechargeCard,
                GroupRechargeCardAssign: GroupRechargeCardAssign,
                settlement: settlement,
                dashboard: dashboard,
                Cpus: Cpus,
                Gpu: Gpu,
                Ram: Ram,
                Game: Game,
                news: news,
                gameStory: gameStory,
                payment: payment,
                statistics: statistics,
                Discussion: Discussion,
                gameTrailer: gameTrailer,
                gameActivity: gameActivity,
                GameIGDB: GameIGDB,
                webhook: webhook,
                EventIGDB: EventIGDB,
                giveaways: giveaways,
                AnalyticsVisitors: AnalyticsVisitors
            },
        }
    }
})

export default store;